import CryptoJS from 'crypto-js'

export function encryptData(plainval, tmk) {
  try {
    const key = deriveKeyFromTMK(tmk)

    // Create AES encrypter in ECB mode with PKCS5 padding
    const encrypted = CryptoJS.AES.encrypt(plainval, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7, // Note: PKCS5 is the same as PKCS7 in this context
    })

    return encrypted.toString() // Returns base64 encoded string
  } catch (e) {
    return e
  }
}

/**
 * Derive encryption key from Terminal Master Key
 * @param {string} tmk - The Terminal Master Key (TMK)
 * @returns {CryptoJS.lib.WordArray} - 16-byte key derived from TMK
 */
function deriveKeyFromTMK(tmk) {
  try {
    // Generate SHA-256 hash of the TMK
    const keyBytes = CryptoJS.SHA256(tmk)

    // Take the first 16 bytes (128 bits) of the hash
    // Converting to a word array with specific length
    const truncatedKey = CryptoJS.lib.WordArray.create(
      keyBytes.words.slice(0, 4), // Take first 4 words (16 bytes)
    )
    return truncatedKey
  } catch (e) {
    return e
  }
}

export async function generateSecval(object, salt) {
  // const sortedResponseBody =  JSON.stringify(object, Object.keys(object).sort())
  return new Promise(async (resolve, reject) => {
    try {
      const sortedResponseBody = JSON.stringify(sortObjectKeys(object))
      const encoder = new TextEncoder()

      const data = encoder.encode(salt + sortedResponseBody)

      const hashBuffer = await window.crypto.subtle.digest('SHA-512', data)

      // Convert the hash buffer to a hexadecimal string
      const hashArray = Array.from(new Uint8Array(hashBuffer))
      const hashHex = hashArray
        .map((byte) => byte.toString(16).padStart(2, '0'))
        .join('')
      resolve(hashHex)
    } catch (error) {
      reject(error)
    }
  })
}

function sortObjectKeys(obj) {
  if (typeof obj !== 'object' || obj === null) {
    return obj
  }

  if (Array.isArray(obj)) {
    return obj.map(sortObjectKeys)
  }

  const sortedKeys = Object.keys(obj).sort()
  const sortedObj = {}

  for (const key of sortedKeys) {
    sortedObj[key] = sortObjectKeys(obj[key])
  }

  return sortedObj
}
